import { Route, Routes } from "react-router-dom";
import { Suspense, lazy } from "react";
import Loader from "../../components/shared/Loader";
import { mobileRoutes, publicRoutes } from "../../config/routes.config";
import { protectedRoutes } from "../../config/routes.config";
import ProtectedRoute from "../../components/auth/ProtectedRoute";
import RoleGuard from "../../components/auth/RoleGuard";
import { ROUTES } from "../../constants/routes";
import NotFound from "../../pages/shared/404";
import ProtectedNewListing from "../../components/auth/ProtectedNewListing";

const DashboardLayout = lazy(() => import("../../layout/DashboardLayout"));
const PublicLayout = lazy(() => import("../../layout/PublicLayout"));

const AllRoutes = () => {
  return (
    <Suspense fallback={<Loader showText={true} className="h-[100vh]" />}>
      <Routes>
        {mobileRoutes.map(({ path, component: Component, key }) => (
          <Route
            key={key}
            path={path}
            element={
              <Suspense
                fallback={<Loader showText={true} className="h-[100vh]" />}
              >
                <Component />
              </Suspense>
            }
          />
        ))}
        <Route element={<PublicLayout />}>
          {publicRoutes.map(({ path, component: Component, key }) => (
            <Route
              key={key}
              path={path}
              element={
                <Suspense
                  fallback={<Loader showText={true} className="h-[100vh]" />}
                >
                  <Component />
                </Suspense>
              }
            />
          ))}
        </Route>

        <Route element={<ProtectedRoute />}>
          <Route element={<DashboardLayout />}>
            {protectedRoutes.map(
              ({ path, component: Component, key, roles }) => (
                <Route key={key} element={<RoleGuard role={roles} />}>
                  <Route element={<ProtectedNewListing path={path} />}>
                    <Route
                      path={path}
                      element={
                        <Suspense
                          fallback={
                            <div className="w-full h-[calc(100vh-var(--h-header))] flex items-center justify-center">
                              <Loader showText={true} className="px-8 py-2 rounded-lg" />
                            </div>
                          }
                        >
                          <Component />
                        </Suspense>
                      }
                    />
                  </Route>
                </Route>
              )
            )}
            <Route
              path={ROUTES.DASHBOARD_ACCESS_DENIED}
              element={<NotFound />}
            />
          </Route>
        </Route>
      </Routes>
    </Suspense>
  );
};

export default AllRoutes;
